module.exports = __webpack_public_path__ + "img/ringcase.885f438.jpg";